import { Memory } from '@/types/orders'
import { create } from 'zustand'

type MemoriesState = {
  memories: Memory[] | null
  page: number
  hasMore: boolean
  isLoadingMore: boolean
  setMemories: (memories: Memory[] | null, hasMore?: boolean) => void
  appendMemories: (memories: Memory[], page: number, hasMore: boolean) => void
  setLoadingMore: (isLoadingMore: boolean) => void
}

// A page can carry the same event twice (one row per order), which would reach
// the carousel as a duplicate React key.
const dedupeByEvent = (memories: Memory[], seen = new Set<string>()) =>
  memories.filter((m) =>
    seen.has(m.event_uid) ? false : (seen.add(m.event_uid), true),
  )

export const useMemoriesStore = create<MemoriesState>((set) => ({
  memories: null,
  page: 0,
  hasMore: false,
  isLoadingMore: false,
  setMemories: (memories, hasMore = false) =>
    set({
      memories: memories && dedupeByEvent(memories),
      page: 0,
      hasMore,
      isLoadingMore: false,
    }),
  appendMemories: (memories, page, hasMore) =>
    set((state) => {
      const seen = new Set((state.memories ?? []).map((m) => m.event_uid))
      return {
        memories: [...(state.memories ?? []), ...dedupeByEvent(memories, seen)],
        page,
        hasMore,
        isLoadingMore: false,
      }
    }),
  setLoadingMore: (isLoadingMore) => set({ isLoadingMore }),
}))
